module.exports = __webpack_public_path__ + "img/thumbnail_ArcticFox_m_albino.7262a1c2.png";